import api from "../../index";

export const GetActivityApi = (data) => api.post('activities-list', data);
